import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

// import { uiConfig } from "../services/firebase";
import { ui } from "../services/firebase";
import { signOut } from "../services/firebase";
import router from "../router/router";
import createMutationsSharer from "vuex-shared-mutations";

Vue.use(Vuex);
export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: "vuex",
      reducer(val) {
        if (val.JWTToken === "") {
          return {
            locale: val.locale,
            countryCode: val.countryCode,
          };
        }
        return val;
      },
    }),
    createMutationsSharer({
      predicate: [
        "SET_FORM",
        "SET_USER_DATA",
        "setMasterData",
        "setCurrentFormData",
        "cleanData",
        "SET_LOGGED_IN",
        "SET_LOCALE",
        "SET_MAX_LENGTH",
        "SET_USER",
        "SET_OVERLAY",
        "SET_ORDERID",
        "Dialog",
        "SET_CURCALLBACK",
        "setWhatsAppData",
        "SET_COUNTRY_CODE",
        "setFileSaved",
        "fileLoaded",
        "SET_JWT_TOKEN",
        "SET_NOTIFICATION_MSG",
        "SET_LAST_LOGOUT",
        "SET_LOG_OUT_COUNT",
      ],
    }),
  ],
  state: {
    link: "",
    locale: "en",
    last_logout: "",
    logout_count: 0,
    countryCode: "IN",
    showlogindialog: false,
    OrderId: "",
    newformroute: {
      newformdialog: false,
      type: "",
    },
    drawer: false,
    current_store_id: "",
    all_store: [],
    overlay: true,
    curcallback: null,
    profile: {
      imageurl: "",
      name: "",
      loggedin: false,
      isSigned: false,
    },
    forms: [],
    whatsAppData: {
      phone: "",
      nationalPhone: "",
    },
    fileSaved: "",
    fileLoaded: false,
    currentForm: {
      id: "default_form",
      pos: 0,
      categs: ["Ordering form", "Catalogue"],
      shopname: "",
      shopdesc: "",
      type: "",
      catalogue: [],
      phone: "",
      amount: 0,
      maxlength: 0,
      currency: "",
      symbol: "",
      createdOn: "",
    },
    currentFormPos: 0,
    snackbar: false,
    snackbartext: "",
    user: {
      loggedIn: false,
      data: null,
    },
    isNotificationMsg: null,
  },
  getters: {
    user(state) {
      return state.user;
    },
    state(state) {
      return state;
    },
  },
  mutations: {
    SET_STORE(state, id) {
      state.current_store_id = id;
    },
    SET_ALL_STORE(state, data) {
      state.all_store = [...state.all_store, data];
    },
    SET_FORM(state, data) {
      state.forms = data;
      state.currentForm = {};
    },
    SET_USER_DATA(state, user) {
      state.profile.isSigned = true;
      state.profile.imageurl = user.photoURL;
      if (user.phoneNumber) state.profile.name = user.phoneNumber;
      else state.profile.name = user.email;
      state.profile.uid = user.uid;
      state.profile.accessToken = user.accessToken;
      state.drawer = user.drawer;
      state.profile.loggedin = user.loggedin;
    },
    setMasterData(state, newfile) {
      while (state.forms.length > 0) state.forms.pop();
      for (var i = 0; i < newfile.length; i++) {
        state.forms.push(newfile[i]);
      }
    },
    setWhatsAppData(state, phone) {
      state.whatsAppData.phone = phone.return_number;
      state.whatsAppData.nationalPhone = phone.national_number;
    },
    setFileSaved(state, data) {
      state.fileSaved = data;
    },
    SET_COUNTRY_CODE(state, value) {
      state.countryCode = value;
    },
    fileLoaded(state, data) {
      state.fileLoaded = data;
    },
    setCurrentFormData(state, newfile) {
      state.currentForm.shopname = newfile.shopname;
      state.currentForm.shopdesc = newfile.shopdesc;
      state.currentForm.type = newfile.type;
      state.currentForm.phone = newfile.phone;
      state.currentForm.currency = newfile.currency;
      state.currentForm.symbol = newfile.symbol;
      state.currentForm.createdOn = newfile.createdOn;
      state.currentForm.pos = newfile.pos;

      while (
        state.currentForm.catalogue &&
        state.currentForm.catalogue.length > 0
      )
        state.currentForm.catalogue.pop();

      if (!newfile.catalogue) newfile.catalogue = [];
      for (var i = 0; i < newfile.catalogue.length; i++)
        state.currentForm.catalogue.push(newfile.catalogue[i]);

      var maxpos = 0;

      for (var j = 0; j < newfile.catalogue.length; j++)
        if (newfile.catalogue[j].pos >= maxpos)
          maxpos = newfile.catalogue[j].pos + 1;

      state.currentForm.maxlength = maxpos;
      // state.currentForm.catalogue.maxlength = maxpos;
    },
    cleanData(state, data) {
      if (data) {
        data = "";
      }
      state.profile.isSigned = false;
      state.profile.imageurl = "";
      state.profile.name = "";
      state.profile.uid = "";
      state.profile.accessToken = "";
      state.overlay = false;
      state.profile.loggedin = false;
    },
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_LOCALE(state, value) {
      state.locale = value;
    },
    SET_MAX_LENGTH(state, value) {
      state.currentForm.catalogue.maxlength = value;
      state.currentForm.maxlength = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    },
    SET_OVERLAY(state, data) {
      state.overlay = data;
    },
    SET_ORDERID(state, data) {
      state.OrderId = data;
    },
    Dialog(state, data) {
      state.showlogindialog = data;
    },
    SET_CURCALLBACK(state, data) {
      state.curcallback = data;
    },
    SET_JWT_TOKEN(state, data) {
      state.JWTToken = data;
    },
    SET_NOTIFICATION_MSG(state, data) {
      state.isNotificationMsg = data;
    },
    SET_LAST_LOGOUT(state, data) {
      state.last_logout = data;
    },
    SET_LOG_OUT_COUNT(state, data) {
      state.logout_count = data;
    },
  },
  actions: {
    fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        commit("SET_USER", {
          displayName: user.displayName,
          email: user.email,
        });
        commit("SET_USER_DATA", user);
      } else {
        commit("SET_USER", null);
        commit("cleanData", null);
      }
    },
    setOverlay({ commit }, data) {
      commit("SET_OVERLAY", data);
    },
    setOrderId({ commit }, data) {
      commit("SET_ORDERID", data);
    },
    setLocale({ commit }, locale) {
      commit("SET_LOCALE", locale);
    },
    setMaxLength({ commit }, value) {
      commit("SET_MAX_LENGTH", value);
    },
    setFileSaved({ commit }, value) {
      commit("setFileSaved", value);
    },
    fileLoaded({ commit }, value) {
      commit("fileLoaded", value);
    },
    setCurCallback({ commit }, data) {
      commit("SET_CURCALLBACK", data);
    },
    async startLogin({ commit }) {
      Vue.nextTick(() => {
        ui();
      });
    },
    setUserData({ commit }, data) {
      commit("SET_USER_DATA", data);
    },
    setDialog({ commit }, data) {
      commit("Dialog", data);
    },
    setMasterData({ commit }, data) {
      // console.log(data);
      commit("setMasterData", data);
    },
    setWhatsAppData({ commit }, data) {
      // console.log(data);
      commit("setWhatsAppData", data);
    },
    setCountryCode({ commit }, value) {
      commit("SET_COUNTRY_CODE", value);
    },
    setCurrentFormData({ commit }, data) {
      commit("setCurrentFormData", data);
    },
    setForm({ commit }) {
      commit("SET_FORM", []);
    },
    setJWTToken({ commit }, value) {
      commit("SET_JWT_TOKEN", value);
    },
    async logout({ commit }) {
      await signOut().then(function() {
        router.push("/");
        commit("SET_USER", null);
        commit("SET_FORM", []);
        commit("cleanData", null);
        commit("setWhatsAppData", "");
        commit("setCurrentFormData", {});
        commit("SET_JWT_TOKEN", "");
      });
    },
    setNotificationMsg({ commit }, value) {
      commit("SET_NOTIFICATION_MSG", value);
    },
    setLastLogout({ commit }, value) {
      commit("SET_LAST_LOGOUT", value);
    },
    setLogOutCount({ commit }, value) {
      commit("SET_LOG_OUT_COUNT", value);
    },
  },
});
